// Put your application javascript here

class App {
    constructor(contentPage) {
        this.$body = document.querySelector('body')
        this.$html = document.querySelector('html')
        this.fixMobile()
        this.verifyForm()

        this.draggables = document.querySelectorAll('.js-draggable') || null
        if (this.draggables.length > 0 && window.innerWidth > 1024) {
            this.draggableSlider()
        }

        this.detectBrowser()

        //? - =========================  bind events
        this.bindEvents()
    }











    //? - =========================  draggables  ========================= -//
    //? - =========================  draggables  ========================= -//
    draggableSlider() {
        this.draggables.forEach(el => {


            let isDown = false;
            let startX;
            let scrollLeft;
            let dragged = 0

            var end = () => {
                isDown = false;
                el.classList.remove('is-dragging');
                dragged = 0
            }

            var start = (e) => {
                isDown = true;
                startX = e.pageX || e.touches[0].pageX - el.offsetLeft;
                scrollLeft = el.scrollLeft;
                dragged = scrollLeft
            }

            var move = (e) => {
                if (!isDown) return;

                e.preventDefault();
                var x = e.pageX || e.touches[0].pageX - el.offsetLeft;
                var dist = (x - startX);
                let moved = scrollLeft - dist
                if (dragged == moved) return
                el.classList.add('is-dragging');
                el.scrollLeft = moved;
            }

            (() => {
                el.addEventListener('mousedown', start);
                el.addEventListener('touchstart', start);

                el.addEventListener('mousemove', move);
                el.addEventListener('touchmove', move);

                el.addEventListener('mouseleave', end);
                el.addEventListener('mouseup', end);
                el.addEventListener('touchend', end);
            })();
        })
    }










    //? - =========================  verifyForm  ========================= -//
    //? - =========================  verifyForm  ========================= -//
    verifyForm() {
        const $challenge_ctn = document.querySelectorAll('.shopify-challenge__container')
        const isform = window.location.hash == '#contact_form'
        if (isform || $challenge_ctn.length > 0) {
            this.$body.classList.remove('is-popup')
            this.$body.classList.add('hide-popup')
        }
    }









    //? - =========================  FIX MOBILE  ========================= -//
    //? - =========================  FIX MOBILE  ========================= -//
    fixMobile() {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)

        let clientWidth = Math.max(document.documentElement.clientWidth, 320)
        let vw = clientWidth * 0.01
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    }

    
    
    
    
    
    
    
    
    
    
    //? - =========================  detect browser  ========================= -//
    //? - =========================  detect browser  ========================= -//
    detectBrowser() {
        // _________ is safari
        var ua = window.navigator.userAgent;
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if(isSafari) { this.$html.classList.add('is-safari') }
        if(iOSSafari) { this.$html.classList.add('is-safari-mob') }
    }









    //? - =========================  resize  ========================= -//
    //? - =========================  resize  ========================= -//
    onResize() {
        this.fixMobile()
    }

    //? - =========================  bindEvents  ========================= -//
    //? - =========================  bindEvents  ========================= -//
    bindEvents() {
        window.addEventListener('resize', this.onResize.bind(this), null)

    }
}

new App(document.querySelector('body'))
